import React from "react"
import { Layout } from "@components/Layout"
import Seo from "../components/Seo/Seo"
import HeroLegals from "@components/Hero/HeroLegals"
import LegalsContent from "@components/LegalsContent"
import { graphql } from "gatsby"

function PrivacyTemplate(props) {
  const { internalName, content } = props?.data?.pageData

  return (
    <Layout>
      <Seo
        title="Workgrid Software Privacy Policy"
        description="Workgrid is a digital workplace platform that simplifies the work day and improves employee experience."
        metaTags="workgrid, digital workplace, enterprise software"
      />
      <HeroLegals title={internalName} />
      <LegalsContent content={content} />
    </Layout>
  )
}

export default PrivacyTemplate

export const PageQuery = graphql`
  query PrivacyPageQuery {
    pageData: contentfulComponentGeneric(
      internalName: { eq: "Privacy Policy" }
    ) {
      id
      internalName
      content: bodyCopy {
        raw
        references {
          id
          link
          label
        }
      }
    }
  }
`
